// extracted by mini-css-extract-plugin
export default {"getStartedBtn":"comp_getStartedBtn__II0Mq","popUpOverlay":"comp_popUpOverlay__WsVe4","popUpWrapper":"comp_popUpWrapper__gFdr4","signInBtn":"comp_signInBtn__8MO3o"};